import src from "IMAGE";
export default { src, width: 600, height: 134, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42k2KOw4AEBAFVSScQUgsF5DQ+N3/Ug+rUUwxmRGaOjQNmLRg4gR7aFCuQNoM8YafE33leNnOnxZO5cLFUwAAAABJRU5ErkJggg=="};
